import { VerifyPayeeCheckResponseCode } from '@seapoint/server/enums';
import { PayeeCheckView } from '../../types/entity-types';
import { isVopPayeeCheck } from './is-vop-payee-check';

const payeeCheckScore = {
  [VerifyPayeeCheckResponseCode.MATCHED]: 3,
  [VerifyPayeeCheckResponseCode.CLOSE_MATCH]: 2,
  [VerifyPayeeCheckResponseCode.NO_MATCH]: 1,
  [VerifyPayeeCheckResponseCode.CHECK_NOT_POSSIBLE]: 1,
  [VerifyPayeeCheckResponseCode.INVALID]: 1,
  [VerifyPayeeCheckResponseCode.GENERAL]: 1,
  [VerifyPayeeCheckResponseCode.INTERNAL_ERROR]: 1,
} satisfies Record<VerifyPayeeCheckResponseCode, number>;

type IsVopPayeeCheckDowngradeArgs = {
  previousCheck: PayeeCheckView;
  newCode: VerifyPayeeCheckResponseCode;
};

export const isVopPayeeCheckDowngrade = ({ previousCheck, newCode }: IsVopPayeeCheckDowngradeArgs) => {
  if (!isVopPayeeCheck(previousCheck)) {
    return true;
  }

  return payeeCheckScore[previousCheck.code] > payeeCheckScore[newCode];
};
